<template>
  <div>
    <el-row>
      <el-col>
        <!-- 远程查询和添加数据-->
        <el-form :inline="true" style="margin: 0" :model="firstFormadd" ref="formRef"
          @submit.native.prevent>
          <el-form-item label="产品名称：">
            <el-autocomplete size="medium" ref="input1" v-model="firstFormadd.PRODUCT_NAME" :fetch-suggestions="querySearchadd"
              placeholder="输入产品名称添加" @select="handleSelect" clearable :popper-append-to-body="false">
              <!--  :popper-append-to-body="false" -->
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="单位：">
            <el-input size="medium" style="width: 80px" v-model="firstFormadd.TYPE_UNIT" disabled></el-input>
          </el-form-item>
          <el-form-item label="数量：">
            <el-input size="medium" @keyup.enter.native="handelTab(3, $event)" ref="input3" v-model="firstFormadd.count">
            </el-input>
          </el-form-item>
          <el-form-item label="单价：">
            <el-input size="medium" @keyup.enter.native="handelTab(2, $event)" ref="input2" v-model="firstFormadd.price">
            </el-input>
          </el-form-item>
          <el-button style="display: inline-block" size="medium" @click="confirmAdd">确认添加</el-button>
        </el-form>
      </el-col>
      <el-col>
        <el-table :data="tableData" border stripe>
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="编码"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="产品单位"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="实收数量"></el-table-column>
          <el-table-column prop="" label="生产入库数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.count" @input="getTotal(scope.row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="" label="入库单价">
            <template slot-scope="scope">
              <el-input v-model="scope.row.price" @input="getTotal(scope.row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="TOTAL" label="入库总价值"></el-table-column>
          <el-table-column label="库位" v-if="WAREHOUSE_MODE == 2">
            <template slot-scope="scope">
              <el-select v-model="scope.row.LOCATION_ID" placeholder="请选择" clearable>
                <el-option v-for="item in locationList" :label="item.CODE" :value="item.ID" :key="item.ID"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column width="55">
            <template slot-scope="scope">
              <el-button type="text" @click="del(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px;">
      <el-col :span="24">
        <el-button size="small" @click="confirmWarehousing" style=" float: right;">确认入库</el-button>
      </el-col>
    </el-row>
    <el-row>
    </el-row>
  </div>
</template>
<script>
import { queryUseSKU } from 'api/skuManage';
import { orderConfirmDetailFun } from 'api/sellOrder';
import { queryPosition } from '@/assets/api/warehouseManager';
import util from '../../assets/common/util';
import http from '../../assets/common/http';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      orderStatus: sessionStorage.getItem('orderStatus'),
      titleData: JSON.parse(sessionStorage.getItem('titleData')),
      tableData: [{ TOTAL: '' }],
      searchForm: {},
      firstFormadd: {
        PRICE: '',
      },
      orderID: '',
      locationList: [],
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
    };
  },
  created() {
    this.queryData();
    // this.queryDepartment();
    this.queryLocation();
    console.log(this.titleData);
  },
  methods: {
    queryData() {
      const params = {
        ORDER_ID: this.titleData.ORDER_ID,
      };
      orderConfirmDetailFun(params).then((res) => {
        if (res[0]) {
          res[0].DETAIL.forEach((item) => {
            item.count = item.REAL_COUNT;
            item.TOTAL = '0.00';
          });
          this.tableData = res[0].DETAIL;
          this.orderID = res[0].TITLE[0].ORDER_ID;
        } else {
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    querySearchadd(queryString, callback) {
      let results = [];
      if (queryString) {
        queryUseSKU({ PRODUCT_NAME: queryString }).then((res) => {
          const tmpArr = res[0].list.map((item) => ({
            CATALOG_NAME: item.CATALOG_NAME,
            PRODUCT_NAME: item.NAME,
            PRODUCT_CODE: item.PRODUCT_CODE,
            TYPE_UNIT: item.TYPE_UNIT,
          }));
          results = tmpArr.map((item) => {
            item.value = `${item.PRODUCT_NAME}（${item.TYPE_UNIT}）`;
            return item;
          });
          callback(results);
        });
      } else {
        callback([]);
      }
    },
    // 挑选
    handleSelect(item) {
      this.firstFormadd = { ...item };
      // console.log(item.PRICE);
    },
    confirmAdd() {
      const reg = /^[0-9]+([.]{1}[0-9]{0,2}){0,1}$/;
      const reg1 = /^[1-9]\d*$/g;
      if (!reg.test(this.firstFormadd.count) || !validation.价格正数0验证(this.firstFormadd.price)) {
        this.$message.show({ text: '请输入正确的数', type: 'warning' });
        return false;
      }
      if (!util.JudgmentUnit(this.firstFormadd.TYPE_UNIT) && !reg1.test(this.firstFormadd.count)) {
        this.$message.show({ text: '请输入正确的数', type: 'warning' });
        return false;
      }
      this.tableData.push({ ...this.firstFormadd, TOTAL: (this.firstFormadd.count * this.firstFormadd.price).toFixed(2) });
      this.firstFormadd = {};
      this.$message.show({ text: '添加成功', type: 'success' });
    },
    confirmWarehousing() {
      let flag = true;
      // 正则：正数
      const reg1 = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      // 正则：正整数
      const reg2 = /^\d+(\.0+)?$/;
      this.tableData.forEach((item) => {
        if (util.JudgmentUnit(item.TYPE_UNIT)) {
          if (!reg1.test(item.count)) {
            flag = false;
            this.$message.show({ text: '生产入库数量请填入正确的数', type: 'warning' });
            return false;
          }
        } else {
          if (!reg2.test(item.count)) {
            flag = false;
            this.$message.show({ text: '非斤、公斤等单位，生产入库数量请填入整数', type: 'warning' });
            return false;
          }
        }
        if (!validation.价格正数0验证(item.price)) {
          flag = false;
          this.$message.show({ text: '入库单价请填入正确的数', type: 'warning' });
          return false;
        }
      });
      if (!flag) {
        return false;
      }
      const params = {
        SERVICE_ID: '15065',
        OTYPE: 1,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_ID: this.orderID,
        PRODUCE_DEPARTMENT_ID: this.$route.params.department,
        PRODUCT_ARRAY: [],
      };
      if (this.tableData.length == 0) {
        this.$message.show({ text: '请添加入库的产品', type: 'warning' });
        return false;
      }
      params.PRODUCT_ARRAY = this.tableData.map((item) => ({
        DETAIL_ID: item.ORDER_DETAIL_ID ? item.ORDER_DETAIL_ID : 0,
        PRODUCT_CODE: item.PRODUCT_CODE,
        PRODUCT_COUNT: item.count,
        PRODUCT_PRICE: item.price,
        TYPE_UNIT: item.TYPE_UNIT,
        LOCATION_ID: item.LOCATION_ID,
      }));
      // console.log(params);
      http.post(params).then((res) => {
        this.$message.show({ text: '入库成功', type: 'success' });
        this.$router.push({ name: 'proReceipt' });
      }).catch((e) => {
        this.$message.show({ text: e, type: 'error' });
      });
    },
    del(row) {
      this.tableData = this.tableData.filter((item) => item.PRODUCT_CODE !== row.PRODUCT_CODE);
    },
    // input框回车自动聚焦下一个input框
    handelTab(i, e) {
      const that = this;
      if (that.$refs[`input${i}`]) {
        that.$nextTick(() => {
          e.target.blur();
          const index = i + 1;
          that.$refs[`input${index}`].focus();
        });
      }
    },
    getTotal(row) {
      if (!isNaN(Number(row.count)) && !isNaN(Number(row.price))) {
        // row = { ...row, TOTAL: (row.count * row.price).toFixed(2) };
        row.TOTAL = (row.count * row.price).toFixed(2);
        console.log((row.count * row.price).toFixed(2));
      }
      // this.$forceUpdate();
    },
    queryLocation() {
      queryPosition()
        .then((result) => {
          if (result.length !== 0) {
            this.locationList = result.map((item) => Object.assign(item, { CODE: item.CODE.toString() }));
          } else {
            this.locationList = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
  },
};
</script>
<style scoped>
.el-autocomplete /deep/ .el-autocomplete-suggestion {
  width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/productionProcessing/proWarehousingDetails.vue